import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * MobileMenu Component
 * Full-screen mobile navigation drawer
 * Opens from the right side with backdrop overlay
 */
export default function MobileMenu({ isOpen, onClose, children }) {
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return (
    <>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] lg:hidden"
        onClick={onClose}
        aria-hidden="true"
      />
      
      {/* Mobile Drawer */}
      <div className="fixed top-0 right-0 bottom-0 w-[85vw] max-w-sm bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 shadow-2xl z-[70] lg:hidden overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h2 className="text-xl font-['Outfit'] font-bold text-white">Menu</h2>
          <button
            onClick={onClose}
            className="p-2 text-white/60 hover:text-white transition-colors touch-target"
            aria-label="Close menu"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Menu Content */}
        <div className="flex flex-col min-h-[calc(100vh-5rem)]">
          {children}
        </div>
      </div>
    </>
  );
}
